(() => {
  'use strict';

  const start = () => {
    const PACKS = Object.freeze({
      starter: { name: 'Llevá 2x1', capsules: 60, bottles: 2, price: 59990 },
      duo: { name: 'Pack 4 meses', capsules: 120, bottles: 4, price: 69990 },
      trio: { name: 'Pack 6 Meses', capsules: 180, bottles: 6, price: 79990 },
      anual: { name: 'Pack Anual', capsules: 360, bottles: 12, price: 109990 }
    });
    const REGULAR_BOTTLE_PRICE = 29995;
    const STORAGE_KEY = 'ginkgo-academic-cart-v1';
    const money = value => `$${new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(value)}`;
    const cartDialog = document.getElementById('cart-dialog');
    const cartContent = document.getElementById('cart-content');
    const toast = document.getElementById('toast');
    const radios = [...document.querySelectorAll('input[name="pack"]')];
    const dialogs = [cartDialog].filter(Boolean);
    const dialogTriggers = new WeakMap();
    let selectedPack = radios.find(radio => radio.checked && PACKS[radio.value])?.value || 'duo';
    let cart = [];
    let toastTimer;
    let previousOverflow = null;
    let checkoutPending = false;

    const element = (tag, className, content) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (content !== undefined) node.textContent = content;
      return node;
    };
    const button = (text, className, attributes = {}) => {
      const node = element('button', className, text);
      node.type = 'button';
      Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
      return node;
    };
    const total = () => cart.reduce((sum, item) => sum + PACKS[item.packId].price * item.quantity, 0);
    const compareTotal = () => cart.reduce((sum, item) => sum + REGULAR_BOTTLE_PRICE * PACKS[item.packId].bottles * item.quantity, 0);
    const count = () => cart.reduce((sum, item) => sum + item.quantity, 0);
    const cartIcon = paths => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.6');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      paths.forEach(d => {
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', d);
        svg.append(path);
      });
      return svg;
    };
    const persist = () => {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: 1, items: cart })); }
      catch { /* La maqueta funciona también con el almacenamiento deshabilitado. */ }
    };
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved?.version === 1 && Array.isArray(saved.items)) {
        const seen = new Set();
        cart = saved.items.filter(item => {
          if (!item || !Object.hasOwn(PACKS, item.packId) || seen.has(item.packId)) return false;
          if (!Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 9) return false;
          seen.add(item.packId);
          return true;
        }).map(({ packId, quantity }) => ({ packId, quantity }));
      }
    } catch { /* Un carrito anterior inválido se descarta. */ }

    const announce = message => {
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.hidden = false;
      toast.classList.add('is-visible');
      toastTimer = setTimeout(() => {
        toast.hidden = true;
        toast.classList.remove('is-visible');
      }, 3200);
    };
    const syncScrollLock = () => {
      const isOpen = dialogs.some(dialog => dialog.open);
      if (isOpen && previousOverflow === null) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else if (!isOpen && previousOverflow !== null) {
        document.body.style.overflow = previousOverflow;
        previousOverflow = null;
      }
      document.body.classList.toggle('dialog-open', isOpen);
    };
    const openDialog = (dialog, trigger) => {
      if (!dialog || dialog.open) return;
      dialogTriggers.set(dialog, trigger instanceof HTMLElement ? trigger : document.activeElement);
      dialog.showModal();
      syncScrollLock();
    };
    const closeDialog = dialog => {
      if (dialog?.open) dialog.close();
    };
    dialogs.forEach(dialog => {
      dialog.addEventListener('close', () => {
        syncScrollLock();
        const trigger = dialogTriggers.get(dialog);
        if (!dialogs.some(other => other.open) && trigger?.isConnected) trigger.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(dialog);
      });
    });

    const renderCart = () => {
      document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(count()); });
      if (!cartContent) return;
      cartContent.replaceChildren();
      const body = element('div', 'sculp-drawer-body');
      if (!cart.length) {
        const empty = element('div', 'cart-empty sculp-drawer-empty');
        empty.append(element('p', '', 'Tu carrito está vacío.'), button('Elegí tu Ginkgo →', 'sculp-drawer-empty-action', { 'data-return-packs': '' }));
        body.append(empty);
        cartContent.append(body);
        return;
      }
      const items = element('div', 'cart-items');
      cart.forEach(item => {
        const pack = PACKS[item.packId];
        const row = element('article', 'cart-item sculp-drawer-line');
        row.dataset.packId = item.packId;
        const image = element('div', 'sculp-drawer-image');
        const img = element('img', 'cart-item-image');
        img.src = (window.GINKGO_ASSET_URLS || {})['pack' + pack.bottles] || `assets/ginkgo-pack-${pack.bottles}-v1.png`;
        img.alt = `${pack.bottles} frascos de Ginkgo Biloba`;
        img.width = 96;
        img.height = 96;
        image.append(img);
        const info = element('div', 'cart-item-info sculp-drawer-details');
        info.append(element('h3', 'sculp-drawer-product-name', pack.name), element('p', 'sculp-drawer-variant', `${pack.bottles} frascos · ${pack.capsules} cápsulas`));
        const prices = element('div', 'sculp-drawer-prices');
        prices.append(element('strong', 'cart-item-price', money(pack.price * item.quantity)));
        const regular = REGULAR_BOTTLE_PRICE * pack.bottles * item.quantity;
        if (regular > pack.price * item.quantity) prices.append(element('del', '', money(regular)));
        info.append(prices);
        const quantity = element('div', 'cart-qty sculp-drawer-quantity');
        quantity.setAttribute('role', 'group');
        quantity.setAttribute('aria-label', `Cantidad de ${pack.name}`);
        const minus = button('−', 'sculp-drawer-quantity-button', { 'data-cart-action': 'decrease', 'aria-label': `Reducir cantidad de ${pack.name}` });
        minus.disabled = item.quantity === 1;
        const amount = element('span', 'sculp-drawer-quantity-value', String(item.quantity));
        amount.setAttribute('aria-label', `Cantidad: ${item.quantity}`);
        const plus = button('+', 'sculp-drawer-quantity-button', { 'data-cart-action': 'increase', 'aria-label': `Aumentar cantidad de ${pack.name}` });
        plus.disabled = item.quantity === 9;
        quantity.append(minus, amount, plus);
        const remove = button('Eliminar', 'cart-remove sculp-drawer-remove', { 'data-cart-action': 'remove', 'aria-label': `Eliminar ${pack.name}` });
        row.append(image, info, remove, quantity);
        items.append(row);
      });
      body.append(items);
      const footer = element('div', 'cart-footer sculp-drawer-footer');
      const totals = element('dl', 'cart-summary sculp-drawer-summary');
      const savings = Math.max(0, compareTotal() - total());
      if (savings > 0) {
        const savingRow = element('div', 'sculp-drawer-saving');
        savingRow.append(element('dt', '', 'Ahorrás'), element('dd', '', money(savings)));
        totals.append(savingRow);
      }
      const totalRow = element('div', 'cart-summary-total sculp-drawer-total');
      totalRow.append(element('dt', '', 'Total'), element('dd', '', money(total())));
      totals.append(totalRow);
      const checkout = button('', 'primary-button sculp-drawer-checkout', { 'data-checkout': '' });
      checkout.disabled = checkoutPending;
      checkout.setAttribute('aria-busy', String(checkoutPending));
      checkout.append(element('span', '', checkoutPending ? 'Abriendo pago…' : 'Finalizar compra'), cartIcon(['M5 12h14', 'm13 6 6 6-6 6']));
      const checkoutError = element('p', 'sculp-drawer-checkout-error');
      checkoutError.dataset.checkoutError = '';
      checkoutError.setAttribute('role', 'alert');
      checkoutError.hidden = true;
      const payment = element('div', 'sculp-drawer-payment');
      const paymentCopy = element('span');
      paymentCopy.append(document.createTextNode('Pago seguro con '), element('strong', '', 'Mercado Pago'));
      payment.append(cartIcon(['M7 11V8a5 5 0 0 1 10 0v3', 'M5 11h14v10H5z', 'M12 15v2']), paymentCopy);
      const paymentSource = document.querySelector('.sculp-purchase-trust img[src*="mercadopago"]');
      if (paymentSource) {
        const paymentImage = element('img');
        paymentImage.src = paymentSource.currentSrc || paymentSource.src;
        paymentImage.alt = '';
        paymentImage.width = 28;
        paymentImage.height = 21;
        payment.append(paymentImage);
      }
      footer.append(totals, checkoutError, checkout, payment);
      cartContent.append(body, footer);
    };
    const setCheckoutPending = pending => {
      checkoutPending = pending;
      const checkout = cartContent?.querySelector('[data-checkout]');
      if (!checkout) return;
      checkout.disabled = pending;
      checkout.setAttribute('aria-busy', String(pending));
      checkout.querySelector('span').textContent = pending ? 'Abriendo pago…' : 'Finalizar compra';
    };
    const showCheckoutError = message => {
      const error = cartContent?.querySelector('[data-checkout-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };
    window.addEventListener('pageshow', () => setCheckoutPending(false));
    const syncSelectedPack = id => {
      if (!Object.hasOwn(PACKS, id)) return;
      selectedPack = id;
      radios.forEach(radio => {
        radio.checked = radio.value === id;
        radio.closest('[data-pack-card], .pack-card, label')?.classList.toggle('is-selected', radio.checked);
      });
      document.querySelectorAll('[data-selected-price]').forEach(node => { node.textContent = money(PACKS[id].price); });
      document.querySelectorAll('[data-selected-pack]').forEach(node => { node.textContent = PACKS[id].name; });
      document.querySelectorAll('[data-add-cart] .elementor-button-text').forEach(node => {
        node.textContent = `AGREGAR AL CARRITO · ${money(PACKS[id].price)}`;
      });
      const selectionStatus = document.querySelector('[data-sculp-pack-status]');
      if (selectionStatus) selectionStatus.textContent = `Seleccionaste ${PACKS[id].name}. Total: ${money(PACKS[id].price)} ARS.`;
    };
    radios.forEach(radio => radio.addEventListener('change', () => {
      if (radio.checked) syncSelectedPack(radio.value);
    }));

    const returnToPacks = () => {
      closeDialog(cartDialog);
      const target = document.getElementById('packs') || radios[0]?.closest('fieldset') || radios[0];
      target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    };
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const add = target.closest('[data-add-cart]');
      if (add) {
        event.preventDefault();
        const existing = cart.find(item => item.packId === selectedPack);
        if (existing?.quantity === 9) {
          announce('Ya agregaste el máximo de 9 unidades de este pack.');
          openDialog(cartDialog, add);
          return;
        }
        if (existing) existing.quantity += 1;
        else cart.push({ packId: selectedPack, quantity: 1 });
        persist();
        renderCart();
        announce(`${PACKS[selectedPack].name} agregado al carrito.`);
        openDialog(cartDialog, add);
        return;
      }
      const openCart = target.closest('[data-open-cart]');
      if (openCart) { event.preventDefault(); renderCart(); openDialog(cartDialog, openCart); return; }
      if (target.closest('[data-close-cart]')) { event.preventDefault(); closeDialog(cartDialog); return; }
      if (target.closest('[data-return-packs]')) { event.preventDefault(); returnToPacks(); return; }
      const action = target.closest('[data-cart-action]');
      if (action && cartContent?.contains(action)) {
        const packId = action.closest('[data-pack-id]')?.dataset.packId;
        const item = cart.find(entry => entry.packId === packId);
        if (!item) return;
        const operation = action.dataset.cartAction;
        if (operation === 'remove') cart = cart.filter(entry => entry !== item);
        else if (operation === 'increase') item.quantity = Math.min(9, item.quantity + 1);
        else if (operation === 'decrease') item.quantity = Math.max(1, item.quantity - 1);
        else return;
        persist();
        renderCart();
        const replacement = [...cartContent.querySelectorAll('[data-pack-id]')].find(row => row.dataset.packId === packId)?.querySelector(`[data-cart-action="${operation}"]:not(:disabled)`);
        const focusTarget = replacement || cartContent.querySelector('[data-cart-action]:not(:disabled), [data-return-packs], [data-checkout]');
        focusTarget?.focus({ preventScroll: true });
        return;
      }
      const checkout = target.closest('[data-checkout]');
      if (checkout) {
        event.preventDefault();
        if (checkoutPending || !cart.length) return;
        const variants = window.GINKGO_SHOPIFY_VARIANTS;
        const items = cart.map(item => ({ id: String(variants?.[item.packId] || ''), quantity: item.quantity }));
        if (!items.every(item => /^[1-9]\d*$/.test(item.id)) || new Set(items.map(item => item.id)).size !== items.length) {
          showCheckoutError('No pudimos abrir el pago de tu selección. Intentá nuevamente en unos minutos. Tu carrito sigue guardado.');
          return;
        }
        const error = cartContent?.querySelector('[data-checkout-error]');
        if (error) error.hidden = true;
        const root = window.Shopify?.routes?.root || '/';
        const lines = items.map(item => `${item.id}:${item.quantity}`).join(',');
        setCheckoutPending(true);
        try {
          window.location.assign(`${root.endsWith('/') ? root : `${root}/`}cart/${lines}`);
        } catch {
          setCheckoutPending(false);
          showCheckoutError('No pudimos abrir el pago. Intentá nuevamente. Tu carrito sigue guardado.');
        }
      }
    });

    const galleryButtons = [...document.querySelectorAll('[data-gallery-src]')];
    const mainImage = document.getElementById('gallery-main');
    const galleryIndex = document.getElementById('gallery-index');
    galleryButtons.forEach((galleryButton, index) => {
      galleryButton.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = galleryButton.dataset.gallerySrc;
        mainImage.alt = galleryButton.dataset.galleryAlt || galleryButton.querySelector('img')?.alt || 'Ginkgo Biloba';
        galleryButtons.forEach(other => {
          const isSelected = other === galleryButton;
          other.setAttribute('aria-pressed', String(isSelected));
          other.classList.toggle('is-active', isSelected);
        });
        if (galleryIndex) galleryIndex.textContent = `${String(index + 1).padStart(2, '0')} / ${String(galleryButtons.length).padStart(2, '0')}`;
      });
    });

    const menuToggle = document.getElementById('menu-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    const closeMenu = () => {
      if (!menuToggle || !mobileNav) return;
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Abrir menú');
      mobileNav.hidden = true;
    };
    menuToggle?.addEventListener('click', () => {
      if (!mobileNav) return;
      const isOpen = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Cerrar menú' : 'Abrir menú');
      mobileNav.hidden = !isOpen;
    });
    mobileNav?.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('a')) closeMenu();
    });
    document.addEventListener('click', event => {
      if (mobileNav && event.target instanceof Node && !mobileNav.contains(event.target) && !menuToggle?.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menuToggle?.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        menuToggle.focus();
      }
    });
    matchMedia('(min-width: 701px)').addEventListener('change', event => { if (event.matches) closeMenu(); });

    const newsletter = document.getElementById('newsletter-form');
    newsletter?.addEventListener('submit', event => {
      event.preventDefault();
      if (!newsletter.reportValidity()) return;
      const status = document.getElementById('newsletter-status');
      if (status) {
        status.textContent = 'La suscripción por correo todavía no está habilitada.';
        status.hidden = false;
      }
      newsletter.reset();
    });

    syncSelectedPack(selectedPack);
    renderCart();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
